/* type1 */
import Home from "../components/Home/Home";
import Search from "../components/Search/Search";
import Details from "../components/Details/Details";
import Catatory from "../components/Catagory/Category";

/* type2 */
import HomeT from "../components_two/Hometwo/Hometwo";
import SearchT from "../components_two/Search/Search";
import CategoryT from "../components_two/Category/Category2";
import DetailsT from "../components_two/Details/Details2";

/* type3 */
import Home3 from "../component_3/Home/Home";
import Details3 from "../component_3/Details/Details";
import Category3 from "../component_3/Category/Category";
import Search3 from "../component_3/Search/Search";

/* type4 */
import Home4 from "../components_4/Home/Home";
import Details4 from "../components_4/Details/Details";
import Category4 from "../components_4/Category/Category";
import Search4 from "../components_4/Search/Search";

let view_type = window.law_template; // 判断模板类型
// view_type = 2;
// view_type = 3;
// view_type = 4;

const router = (type) => {
  switch (type) {
    case 2: {
      return [
        {
          path: "/",
          element: <HomeT />,
        },
        {
          path: "/page/search",
          element: <SearchT />,
        },
        {
          path: "/page/category",
          element: <CategoryT />,
        },
        {
          path: "/page/details",
          element: <DetailsT />,
        },
      ];
    }
    case 3: {
      return [
        {
          path: "/",
          element: <Home3 />,
        },
        {
          path: "/page/search",
          element: <Search3 />,
        },
        {
          path: "/page/category",
          element: <Category3 />,
        },
        {
          path: "/page/details",
          element: <Details3 />,
        },
      ];
    }
    case 4: {
      return [
        {
          path: "/",
          element: <Home4 />,
        },
        {
          path: "/page/search",
          element: <Search4 />,
        },
        {
          path: "/page/category",
          element: <Category4 />,
        },
        {
          path: "/page/details",
          element: <Details4 />,
        },
      ];
    }
    default: {
      return [
        {
          path: "/",
          element: <Home />,
        },
        {
          path: "/page/search",
          element: <Search />,
        },
        {
          path: "/page/details",
          element: <Details />,
        },
        {
          path: "/page/category",
          element: <Catatory />,
        },
      ];
    }
  }
};

const ResRouter = router(view_type);

export default ResRouter;
